import axios from 'core/common/config/axios-config';
import {parseId} from "core/common/utils/utils";
import {observable} from "mobx";
import {JobInfo, TriggerInfo} from "core/job/jobDomain";
import {IDomainObject} from "core/form/formUtils";


class  JobService  {

  @observable public availableJobs: {[key: string]: string[]};
  @observable public jobObject: JobInfo;


  readAvailableJobs(): Promise<{[key: string]: string[]}> {
    return axios.get('/core/job-available')
      .then(response => response.data);
  }

  readJob(id): Promise<JobInfo> {
    let strings = parseId(id);
    return axios.get('/core/job/' + strings[0] + '/' + strings[1])
      .then(response => new JobInfo(response.data));
  }

  jobSave(jobDto): Promise<IDomainObject> {
    return axios.post('/core/job', jobDto, {showPrettyError: true})
      .then((response) => response.data);
  }

  triggerExist(name: string) {
    return axios.get('/core/job-trigger-exists', {params:{name}})
      .then(response => response.data);
  }

  cronCheck(cronexpression: string) {
    return axios.get('/core/job-trigger-check-cron', {params:{cronexpression}})
      .then(response => response.data);
  }

  oneOff(jobObject) {
    return axios.post('/core/job-one-off', jobObject, {showPrettyError: true})
      .then((response) => response.data);
  }

  deleteJob(jobObject) {
    return axios.delete('/core/job/' + jobObject.group + '/' + jobObject.name, {showPrettyError: true})
      .then((response) => response.data);
  }

  switchState(trigger: TriggerInfo): Promise<any> {
    return axios.post('/core/job-trigger-switch-state', trigger, {showPrettyError: true})
      .then((response) => response.data);
  }

}

export default new JobService();




// WEBPACK FOOTER //
// ./src/core/job/jobService.ts